<template>
  <div>
    <img v-if='attrs && attrs.img !== void 0'
      slotscope='{row}'
      :src="row[slot]||''"
      xsrc="@/assets/logo.png|/static/favicon.png"
      style="width: 100%;max-width: 100px;height: 100px;object-fit: contain;" class="cPointer"
      alt=" "
      :title=" row[slot] ? '点击预览图片: ' + row[slot] : '' "
      onload="this.style.display=''"
      onerror="this.style.display='none'"
      @click.stop='
        row[attrs.img] || row[slot]
        ? $trigger("*preview", row[attrs.img] || row[slot])
        : null
      '
      >
    <slot v-else :row='row'></slot>

  </div>
</template>

<script >
const Allcols = { __proto__: null }; // ["预览图片",35]
// console.error( Allcols ); 
export default {
  data() {
    return {
      row: 0,
      attrs: 0,
      slot: 0,
    };
  },

  watch: {

  },

  methods: {


  },

  // activated() {
  //   console.warn('激活了.........');
  // },

  created() {
    const data = this.$vnode.data;
    this.slot = data.slot;
    this.attrs = data.attrs;
    // console.error(data,44444444);
    // const slot = this.$vnode.data.slot;
    // console.warn('开始创建...');
    // Allcols[ this._uid ] = this;
    // console.warn( this.$el, this._uid );
    // this.myBind('$el',(el,old)=>{
    //   if( !el ) return;
    //   let Td = el.parentElement;
    //   if( !Td ) return;
    //   if ( el === old ) return;
    //   console.error( Td.index, Td.row, Td.slotname, this._hookstate, this._uid, document.contains(el), document.contains(Td), this, [ old, el ] );
    //   el.textContent = Td.row[ Td.slotname ];
    // });
  },

  mounted() {
    const hasSlot = this.$slots.default || this.$scopedSlots.default || this.slot;

    const El = this.$el, Div = this.$parentElement = El.parentElement;

    hasSlot
    ? this.row = Div.row
    : El.textContent = ( this.row = Div.row )[ Div.slotname ];

    // console.error(El,Div,document.contains(El), document.contains(Div),this._isDestroyed);
    Div.myBind('row',(row,old,slot)=>{
        if( !Div.offsetParent ) return delete Div.row;
        if( row === old ) return;
        // console.warn( Div.offsetParent );
        if( old[ slot = Div.slotname ] === ( slot = row[ slot ] ) ) return;
        this.row = row;
        !hasSlot && ( El.textContent = slot );
        // console.warn( [ row, old ], 7777777, Div.slotname, document.contains(El), document.contains(Div), Div );
    });


    // console.warn( this.$el, Div.table, this );
    // this.$parent.$watch('data',data=>{
    //   console.warn(data,'11111111111');
    // });
  },

  deactivated() {
    // console.warn('取消激活.......', [ this ], this._uid );
    // delete this.$el;
    delete (this.$parentElement||0).row;
  },

  destroyed( ) {
    // console.warn('破坏了.......', this, this._uid );
    // delete this.$el;
    delete (this.$parentElement||0).row;
  },


};

</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/$icol.vue